{
  "name": "deepspace",
  "version": "0.42.3",
  "engines": {
    "node": ">=22.15.0 <23 || >=24 <25 || >=26 <27"
  },
  "description": "DeepSpace SDK — build real-time collaborative apps on Cloudflare Workers",
  "type": "module",
  "sideEffects": false,
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "bin": {
    "deepspace": "dist/cli.js"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./schema": {
      "types": "./dist/schema.d.ts",
      "import": "./dist/schema.js"
    },
    "./worker": {
      "types": "./dist/worker.d.ts",
      "import": "./dist/worker.js"
    },
    "./server": {
      "types": "./dist/server.d.ts",
      "import": "./dist/server.js"
    },
    "./testing": {
      "types": "./dist/testing.d.ts",
      "import": "./dist/testing.js"
    },
    "./testing/mcp": {
      "types": "./dist/testing-mcp.d.ts",
      "import": "./dist/testing-mcp.js"
    },
    "./build": {
      "types": "./dist/build.d.ts",
      "import": "./dist/build.js"
    },
    "./expo": {
      "types": "./dist/expo.d.ts",
      "import": "./dist/expo.js"
    },
    "./native": {
      "types": "./dist/native.d.ts",
      "react-native": "./dist/native.js",
      "browser": "./dist/native.web.js",
      "import": "./dist/native.js"
    },
    "./documentation": {
      "types": "./dist/documentation.d.ts",
      "import": "./dist/documentation.js"
    },
    "./documentation/react": {
      "types": "./dist/documentation-react.d.ts",
      "import": "./dist/documentation-react.js"
    }
  },
  "files": [
    "dist",
    "features",
    "CHANGELOG.md",
    "ios",
    "expo-module.config.json"
  ],
  "scripts": {
    "build": "node ../../scripts/clean-artifacts.mjs dist --tsbuildinfo && tsup",
    "type-check": "tsc --noEmit && tsc --noEmit -p tsconfig.expo.json",
    "test": "vitest run",
    "test:documentation-browser": "playwright test --config src/documentation/runtime/__browser__/playwright.config.ts",
    "clean": "node ../../scripts/clean-artifacts.mjs dist --tsbuildinfo",
    "prepublishOnly": "pnpm build"
  },
  "dependencies": {
    "@ai-sdk/anthropic": "4.0.58",
    "@ai-sdk/openai": "4.0.71",
    "@ai-sdk/openai-compatible": "3.0.53",
    "@clack/prompts": "^1.2.0",
    "@mdx-js/mdx": "^3.1.1",
    "acorn": "^8.16.0",
    "ai": "7.0.107",
    "better-auth": "1.6.23",
    "citty": "^0.2.0",
    "cross-spawn": "^7.0.6",
    "esbuild": "^0.27.0",
    "highlight.js": "^11.11.1",
    "hono": "^4.13.7",
    "jose": "^6.1.0",
    "marked": "^18.0.7",
    "mdast-util-gfm": "^3.1.0",
    "mdast-util-to-markdown": "^2.1.2",
    "rehype-highlight": "^7.0.2",
    "remark-frontmatter": "^5.0.0",
    "remark-gfm": "^4.0.1",
    "sanitize-html": "^2.17.7",
    "smol-toml": "^1.7.1",
    "yaml": "^2.9.0",
    "yjs": "^13.6.0",
    "zod": "^4.3.6"
  },
  "peerDependencies": {
    "@playwright/test": ">=1.40.0",
    "clsx": ">=2.0.0",
    "lucide-react": ">=0.400.0",
    "react": "^18.0.0 || ^19.0.0",
    "react-dom": "^18.0.0 || ^19.0.0",
    "tailwind-merge": ">=2.0.0",
    "expo-crypto": "~57.0.0",
    "expo-linking": "~57.0.0",
    "expo-secure-store": "~57.0.0",
    "expo-web-browser": "~57.0.0",
    "react-native": ">=0.76.0",
    "expo": "~57.0.0"
  },
  "peerDependenciesMeta": {
    "@playwright/test": {
      "optional": true
    },
    "react": {
      "optional": true
    },
    "react-dom": {
      "optional": true
    },
    "clsx": {
      "optional": true
    },
    "tailwind-merge": {
      "optional": true
    },
    "lucide-react": {
      "optional": true
    },
    "expo-crypto": {
      "optional": true
    },
    "expo-linking": {
      "optional": true
    },
    "expo-secure-store": {
      "optional": true
    },
    "expo-web-browser": {
      "optional": true
    },
    "react-native": {
      "optional": true
    },
    "expo": {
      "optional": true
    }
  },
  "devDependencies": {
    "@cloudflare/workers-types": "^4.20241205.0",
    "@playwright/test": "^1.59.1",
    "@types/better-sqlite3": "^7.6.12",
    "@types/cross-spawn": "^6.0.6",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "@types/sanitize-html": "^2.16.1",
    "better-sqlite3": "^12.0.0",
    "clsx": "^2.1.1",
    "framer-motion": "^12.38.0",
    "jsdom": "^29.1.1",
    "lucide-react": "^1.7.0",
    "react-router-dom": "^7.1.0",
    "tailwind-merge": "^3.5.0",
    "tsup": "^8.3.0",
    "typescript": "^5.7.0",
    "vitest": "^4.1.0"
  },
  "keywords": [
    "deepspace",
    "cloudflare-workers",
    "durable-objects",
    "real-time",
    "collaborative",
    "sdk"
  ],
  "license": "Apache-2.0",
  "homepage": "https://deep.space",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/deepdotspace/deepspace.git",
    "directory": "packages/deepspace"
  },
  "bugs": {
    "url": "https://github.com/deepdotspace/deepspace/issues"
  }
}
